import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { isLessThan7DaysSince } from '@hotjar/webapp/features/Playbacks/utils/isLessThan7DaysSince';
import { Store } from '../../../store/player/types';
import { readOnly } from './readOnly';

/**
 * Checks whether to show the Feedback prompt in the Recording end modal.
 *
 * The Prompt will show if:
 * - we have a user,
 * - user is not read-only,
 * - user has not set up any Incoming Feedback widgets yet,
 * - it has been less than 7 days since the prompt was first shown.
 */
export const setupFeedbackPrompt = (store: Store): void => {
  const { hasNoIncomingFeedback, user, setShowFeedbackPrompt } = store.getState();
  const userId = user && user.user_id;

  if (!userId || readOnly(store) || !hasNoIncomingFeedback) {
    return;
  }

  const promptInitTimestamp = Number(LocalStorage.get('playbackFeedbackPromptInitTime'));

  if (promptInitTimestamp && isLessThan7DaysSince(promptInitTimestamp)) {
    setShowFeedbackPrompt(true);
  } else if (!promptInitTimestamp) {
    LocalStorage.set('playbackFeedbackPromptInitTime', Date.now());
    setShowFeedbackPrompt(true);
  } else {
    setShowFeedbackPrompt(false);
  }
};
